import type { LocationsListTableRowActionsProps } from "./locations-list-table-row-actions.type";

import { isSector } from "@/entities/location";
import { useListTableRowActions } from "@/modules/list-table-row-actions";
import LocationEdit from "@/modules/location/location-edit";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelEditButtonLegacy from "@/modules/model-edit-button-legacy";
import ModelViewButton from "@/modules/model-view-button";

const LocationsListTableRowActions = ({
  location,
  isSectorsTable,
}: LocationsListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  const isSectorMode = isSectorsTable || isSector(location);
  const translationKey = isSectorMode ? "sector" : undefined;

  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="location"
        item={location}
        onClick={closePopover}
      />
      <ModelEditButtonLegacy
        type="text"
        modelKey="location"
        item={location}
        translationKey={translationKey}
        component={<LocationEdit locationId={location.id} />}
        onClick={closePopover}
      />
      <ModelDeleteButton
        type="text"
        modelKey="location"
        item={location}
        translationKey={translationKey}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};

export default LocationsListTableRowActions;
